<script>
import { ref, onMounted } from 'vue'
import { Splide } from '@splidejs/splide'
import { Intersection } from '@splidejs/splide-extension-intersection'

const DEFAULTS = {
  updateOnMove: true,
  autoplay: true,
  drag: false,
  interval: 2000,
  speed: 700,
  arrows: false,
  pagination: false,
  type: 'loop',
  focus: 'center',
  perMove: 1,
  perPage: 2,
  gap: '-20px',
  padding: 0,
  clones: 2
}

export default {
  name: 'renderless-dual-splide',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup (props, { slots }) {
    const firstSplide = ref(null)
    const secondSplide = ref(null)
    const pausePlayBtn = ref(null)
    const isPaused = ref(false)

    onMounted(() => {
      const options = { ...DEFAULTS, ...props.options }
      const splide1 = new Splide(firstSplide.value, { ...options, direction: 'rtl' }).mount({ Intersection })
      const splide2 = new Splide(secondSplide.value, { ...options, direction: 'ltr' }).mount({ Intersection })

      const play = () => {
        splide1.Components.Autoplay.play()
        splide2.Components.Autoplay.play()
        splide1.options = splide2.options = { drag: false }
        isPaused.value = false
      }
      const pause = () => {
        splide1.Components.Autoplay.pause()
        splide2.Components.Autoplay.pause()
        splide1.options = splide2.options = { drag: true }
        isPaused.value = true
      }

      firstSplide.value.onclick = pause
      secondSplide.value.onclick = pause
      pausePlayBtn.value.onclick = () => isPaused.value ? play() : pause()
    })

    return () => slots.default({
      firstSplide,
      secondSplide,
      pausePlayBtn,
      isPaused
    })
  }
}
</script>
